var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabaseGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONS/database"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.8335 16.5C34.7746 16.5 42.8335 13.8137 42.8335 10.5C42.8335 7.18629 34.7746 4.5 24.8335 4.5C14.8924 4.5 6.8335 7.18629 6.8335 10.5C6.8335 13.8137 14.8924 16.5 24.8335 16.5Z",
    stroke: "#78C753",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.8335 24.5C42.8335 27.82 34.8335 30.5 24.8335 30.5C14.8335 30.5 6.8335 27.82 6.8335 24.5",
    stroke: "#78C753",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.8335 10.5V38.5C6.8335 41.82 14.8335 44.5 24.8335 44.5C34.8335 44.5 42.8335 41.82 42.8335 38.5V10.5",
    stroke: "#78C753",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseGreen);
export default __webpack_public_path__ + "static/media/database-green.666c4339f30c97adfc9f4766a8a8dcde.svg";
export { ForwardRef as ReactComponent };